var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M17.22 2.27L2.48 8.39c-.35.14-.32.66.06.74l6.79 1.54 1.53 6.79c.09.37.6.41.75.06l6.12-14.74a.4.4 0 00-.51-.51M3.92 8.64l11.77-4.89-6.15 6.16-5.62-1.27zm7.44 7.44l-1.27-5.61 6.16-6.16-4.9 11.77z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }